import React, { useEffect } from 'react'
import { Checkbox, Form, Radio, Input, Select } from 'antd'

import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { runInAction, set, toJS } from 'mobx'


const StepOne = () => {
    const { RegisterStore } = useStore()

    //获得table数据
    useEffect(() => {
        RegisterStore.provinceLinkage()
        // eslint-disable-next-line
    }, [])


    const plainOptions = ['大田种植', '蔬菜种植', '畜牧养殖', '产品加工', '农机作业', '其他'];
    const onChange = (checkedValues) => {
        RegisterStore.newCheckedValues = { ...checkedValues }
    };
    //五级联动
    const province = async (value) => {
        await RegisterStore.cityLinkage(value)
        runInAction(() => {
            set(RegisterStore, { AreaCode1: value })
        })
    }
    const city = async (value) => {
        await RegisterStore.countyLinkage(value)
        runInAction(() => {
            set(RegisterStore, { AreaCode2: value })
        })
    }
    const county = async (value) => {
        await RegisterStore.townshipLinkage(value)
        runInAction(() => {
            set(RegisterStore, { AreaCode3: value })
        })
    }
    const township = async (value) => {
        await RegisterStore.villageLinkage(value)
        runInAction(() => {
            set(RegisterStore, { AreaCode4: value })
        })
    }
    const village = async (value) => {
        runInAction(() => {
            set(RegisterStore, { AreaCode5: value })
        })
    }
    return (
        <>
            <Form.Item
                label="主体名称"
                name="nickname"
                rules={[
                    {
                        required: true,
                        message: '请输入账户',
                    }
                ]}
                style={{ height: '40px' }}
            >
                <Input size="large" placeholder="请输入账户" />
            </Form.Item>
            <Form.Item label={<div><i style={{ color: 'red' }}>* </i>选择地区</div>}>

                <Form.Item name='province' noStyle rules={[
                    {
                        required: true,
                        message: '请输入省',
                    }
                ]}>
                    <Select
                        placeholder='省'
                        onChange={province}
                        options={toJS(RegisterStore.province)}
                        style={{ width: '90px', marginRight: '6px' }}

                    />
                </Form.Item>
                <Form.Item name="city" noStyle rules={[
                    {
                        required: true,
                        message: '请输入市',
                    }
                ]}>
                    <Select
                        placeholder='市'
                        onChange={city}
                        style={{ width: '90px', marginRight: '6px' }}
                        options={toJS(RegisterStore.city)}
                    />
                </Form.Item>
                <Form.Item name="county" noStyle rules={[
                    {
                        required: true,
                        message: '请输入县',
                    }
                ]}>
                    <Select
                        placeholder='县'
                        onChange={county}
                        style={{ width: '90px', marginRight: '6px' }}
                        options={toJS(RegisterStore.county)}
                    />
                </Form.Item>
                <Form.Item name='township' noStyle rules={[
                    {
                        required: true,
                        message: '请输入乡',
                    }
                ]}>
                    <Select
                        placeholder='乡'
                        onChange={township}
                        options={toJS(RegisterStore.township)}
                        style={{ width: '90px', marginRight: '6px' }}
                    />
                </Form.Item>
                <Form.Item name='village' noStyle rules={[
                    {
                        required: true,
                        message: '请输入村',
                    }
                ]}>
                    <Select
                        placeholder='村'
                        onChange={village}
                        options={toJS(RegisterStore.village)}
                        style={{ width: '90px' }}
                    />
                </Form.Item>
            </Form.Item>
            <Form.Item name="identity" label="选择身份" rules={[
                {
                    required: true,
                    message: '选择身份',
                },
            ]}>
                <Radio.Group>
                    <Radio value="1">合作社</Radio>
                    <Radio value="2">种植大户</Radio>
                    <Radio value="3">家庭农场</Radio>
                    <Radio value="4">龙头企业</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="productions" label="生产情况" rules={[
                {
                    required: true,
                    message: '请选择生产情况',
                },
            ]}>
                <Checkbox.Group onChange={onChange} options={plainOptions} ></Checkbox.Group>
            </Form.Item>
        </>
    )
}

export default observer(StepOne)

